import { render, staticRenderFns } from "./ProdLocationAdjustment.vue?vue&type=template&id=dc38d246"
import script from "./ProdLocationAdjustment.vue?vue&type=script&lang=js"
export * from "./ProdLocationAdjustment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports